import { AutomaticReportTimeSlot } from "../AutomaticReportCompetitor";
import AutomaticReportJobBase from "./Base";

export type AutomaticReportJobCompetitorSnapshotAttributes = {
  compare?: boolean;
  comparisonStartsAt?: string | null;
  comparisonEndsAt?: string | null;
  timeSlots?: boolean;
  timeSlotsFilter?: AutomaticReportTimeSlot[] | null;
};

export type AutomaticReportJobCompetitorSnapshot = {
  startsAt?: string;
  endsAt?: string;
  automaticReport?: {
    name?: string;
    active?: boolean;
    granularityKind?: string;
    granularityQuantity?: number | null;
    granularityRange?: number[] | null;
    weekType?: string | null;
    competitorAttributes?: AutomaticReportJobCompetitorSnapshotAttributes;
  };
  reportTemplate?: {
    name?: string;
    // Left loosely typed: it is handed straight to buildCompetitorDetailRows, which
    // reads it duck-typed. The backend jobs INDEX additionally injects the resolved
    // competitorsNames / agenciesNames / grpTarget into this node (never on #show).
    competitorAttributes?: Record<string, unknown>;
  };
};

export default class AutomaticReportJobCompetitor extends AutomaticReportJobBase {
  static type = "automaticReportJobCompetitors";

  kind!: "competitor";
  data!: AutomaticReportJobCompetitorSnapshot;
}
